export default __webpack_public_path__ + "static/1475-02564ef1b71fc8e7769c185525ac8928.gif";